<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  created() {
    // 从 Cookie 恢复用户信息
    this.$store.commit("getToken");
    this.$store.commit("getUser");
    this.$store.commit("getUserId");
    this.$store.commit("getRole");
  },
};
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 文字墨：正文与标题统一用 #1A1A1A */
  color: #1a1a1a;
}

nav a {
  font-weight: bold;
  color: #1a1a1a;
}

nav a.router-link-exact-active {
  color: #ec5435;
}

/* 全局强制 Tabbar 固定在底部 */
.van-tabbar--fixed {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 9999 !important;
}

/* 确保 Vant tabbar 不被任何父元素影响 */
.van-tabbar {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 9999 !important;
}
</style>
